module.exports = __webpack_public_path__ + "img/gdpr.c4f30f1c.svg";